module.exports = __webpack_public_path__ + "resources/img/sp_solution_game.9f55750aeb57dfc85437c0ea51ffef9f.png";